import { Component, OnInit } from "@angular/core";
import { SharedService } from "@shared/services/shared.service";
import { AuthService } from "@shared/auth/auth.service";
import { UserService } from "app/services/user/user.service";

@Component({
  selector: 'account-information',
  templateUrl: './account-information.component.html',
  styleUrls: ['./account-information.component.scss']
})

export class AccountInformationComponent implements OnInit {

  public email: string = '';
  public username: string = '';
  public roles: string[] = [];
  loading: boolean = false;

  constructor(
              public sharedService: SharedService,
              private authService: AuthService,
              private userService: UserService) { }

  ngOnInit(): void {
    this.loading = true;
    this.userService.getUserInfo().subscribe(
      response =>
      {
        this.username = response.fullName;
        this.email = response.email;
        this.roles = response.roles;
        this.loading = false;
      },
      error => {
        console.log('error', error);
        this.loading = false;
      });

  }

}
